import React, { Suspense } from "react";
import Svg from "./components/svgs/svg";
import rg4js from 'raygun4js';
import { useEffect } from "react";
import { readWidgetProps } from "./common/server/readWidgetProps";
import WidgetPortal from "./common/WidgetPortal";

rg4js('apiKey', 'WTaSVCys1E9G1J1JetTctg');
rg4js('enableCrashReporting', true);

/**
 * Widget mount probes.
 *
 * Each Sitefinity widget view emits a container with a known id; the bundle is
 * loaded on every page that hosts one, and each form renders only when its own
 * container is present. Read at module scope because the widget views emit the
 * script tags at "bottom", so the DOM is already parsed.
 */
const onlineBookingPage = document.getElementById("online-booking");
const virtualSurveyPage = document.getElementById("virtual-survey");

/**
 * Server data for the Virtual Survey widget arrives as props, serialised by its
 * widget view into a <script type="application/json"> block. The original
 * Online Booking widget instead scrapes ~40 hidden inputs from inside its own
 * component, which is left untouched here.
 */
const virtualSurveyProps = virtualSurveyPage ? readWidgetProps("virtual-survey-props") : null;

/**
 * Both forms are code-split so a visitor only downloads the one on their page.
 * This depends on "homepage" in package.json being set to /ClientApp/build -
 * without it webpack resolves chunks against "/" and they 404.
 *
 * Chunk filenames are NOT stable across builds: the widget views must resolve
 * their script tags from build/asset-manifest.json rather than hardcoding
 * names like "2.*.chunk.js".
 */
const OnlineBooking = React.lazy(() => import("./components/OnlineBooking"));
const VirtualSurvey = React.lazy(() => import("./virtualSurvey/VirtualSurvey"));

const App = (props) => {
  // useEffect(() => {
  //   const unloadCallback = (event) => {
  //     event.preventDefault();
  //     event.returnValue = "";
  //     return "";
  //   };

  //   window.addEventListener("beforeunload", unloadCallback);
  //   return () => window.removeEventListener("beforeunload", unloadCallback);
  // }, []);

  return (
    <div>
      <Svg />
      <Suspense fallback={null}>
        {onlineBookingPage && <OnlineBooking />}
        {virtualSurveyPage && (
          <WidgetPortal target={virtualSurveyPage}>
            <VirtualSurvey {...virtualSurveyProps} />
          </WidgetPortal>
        )}
      </Suspense>
    </div>
  );
};

export default App;
